export enum StoreTypologyEnum {
    OUTLET = 'Outlet',
    OTHER = 'Other'
  }

export const storeTypologiesArray = [StoreTypologyEnum.OUTLET, StoreTypologyEnum.OTHER]